import React from "react";
import PropTypes from "prop-types";
import SectionCard from "../../profiles/SectionCard";

// Stand-in rows behind the blur, from the design. Never real requests: an unentitled viewer must not
// receive the reporter's posts in any form, blurred or not.
const PLACEHOLDER_POSTS = [
  {
    title: "Relationship experts and psychotherapists needed on Red Flags",
    text: "I'm seeking licensed mental health professionals who specialize in relationships to provide commentary.",
  },
  {
    title: "Exploring the Latest Trends in Travel and Fashion",
    text: "Seeking insights from travel and fashion experts to share their thoughts for an article on current trends.",
  },
  {
    title: "Travel and Fashion Influencers to Share Their Insights",
    text: "In search of industry leaders in travel and fashion to contribute their views for a feature.",
  },
  {
    title: "Call for Fashion and Travel Gurus to Discuss Current Trends",
    text: "I am looking for trendsetters in the travel and fashion industries to provide their insights.",
  },
];

/**
 * MediaRequestsTeaser — the upsell shown where the Posts card would be (Figma "Free View of Media
 * Posts"): an upgrade panel over blurred placeholder rows.
 *
 * It stands in for the real (paid, server-gated) Posts card when the viewer is authenticated but
 * unentitled, and links to the pricing page. This is chrome only — it renders no request data — and
 * the caller decides whether to show it (never for anonymous viewers, whose exposure is a separate
 * decision).
 *
 * @param {Object} props
 * @param {string} [props.name] - The journalist's name (falsy → "this journalist")
 * @param {string} [props.upgradeUrl] - Pricing-page URL for the CTA (falsy → no CTA rendered)
 */
function MediaRequestsTeaser({ name = undefined, upgradeUrl = undefined }) {
  return (
    <SectionCard id="media-section-requests-teaser" title="Posts">
      <div className="media-posts-upsell">
        <div className="d-flex align-items-center paragraph-md fw-bold">
          <i className="fa-solid fa-eye media-posts-upsell-icon me-2" aria-hidden="true" />
          View their posted opportunities!
        </div>
        <div className="paragraph-md">
          Upgrade your plan to view recent opportunities from {name || "this journalist"} & pitch smarter.
        </div>
        {upgradeUrl && (
          <a href={upgradeUrl} className="btn media-posts-upsell-cta">
            Upgrade
          </a>
        )}
      </div>

      <ul className="media-posts media-posts-placeholder list-unstyled mb-0" aria-hidden="true">
        {PLACEHOLDER_POSTS.map((post) => (
          <li key={post.title} className="media-post d-flex">
            <div className="media-post-logo" />
            <div className="media-post-body">
              <div className="paragraph-md fw-bold">{post.title}</div>
              <p className="media-post-preview paragraph-md text-secondary mb-0">{post.text}</p>
            </div>
          </li>
        ))}
      </ul>
    </SectionCard>
  );
}

MediaRequestsTeaser.propTypes = {
  name: PropTypes.string,
  upgradeUrl: PropTypes.string,
};

export default MediaRequestsTeaser;
